<template>
    <section class="article">

        <p>
            <strong><span>{{ trans('pp1') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('ipprpo') }}</span>
        </p>
        <p>{{ trans('po80') }}: 331700720148</p>
        <p>{{ trans('po91') }}: 326330000023853</p>
        <p>{{ trans('po82') }}: 40802810032230008497</p>
        <p>{{ trans('po83') }}</p>
        <p>{{ trans('po84') }}. счет: 30101810600000000786</p>
        <p>{{ trans('po85') }}: 044030786</p>
        <p>
            <span lang="EN-US">Email: <a href="mailto:arendaipzakharova@yandex.ru" class="article__link">arendaipzakharova@yandex.ru</a></span>
        </p>
        <p>
            <span>{{ trans("Telephone") }}: <a href="tel:+79308860575" class="article__link">+7 930 886 0575</a></span>
        </p>
        <p>{{ trans('po87') }}</p>
        <p>
      <span>{{ trans('pp5') }}
        <a href="https://batnorton.com" class="article__link">batnorton.com</a>
        {{ trans('pp6') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp7') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp8') }}.</span>
        </p>
        <p>
            <strong><span>{{ trans('pp9') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp10') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp11') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp12') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp13') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp14') }}.</span>
        </p>

        <p>
            <strong><span>{{ trans('pp15') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp16') }}:</span>
        </p>
        <p>
            <span>{{ trans('pp17') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp18') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp19') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp20') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp21') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp22') }}.</span>
        </p>

        <p>
            <strong><span>{{ trans('pp23') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp24') }}:</span>
        </p>
        <p>
            <span>{{ trans('pp25') }};</span>
        </p>
        <p>
            <span>{{ trans('pp26') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp27') }};</span>
        </p>
        <p>
            <span>{{ trans('pp28') }};</span>
        </p>
        <p>
            <span>{{ trans('pp29') }}.</span>
        </p>
        <p>
            <strong><span>{{ trans('pp30') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp31') }}:</span>
        </p>
        <p>
            <span>{{ trans('pp32') }};</span></p>
        <p>
            <span>{{ trans('pp33') }};</span>
        </p>
        <p>
            <span>{{ trans('pp34') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp35') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp36') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp37') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp38') }}:</span>
        </p>
        <p>
            <span>{{ trans('pp39') }};</span>
        </p>
        <p>
            <span>{{ trans('pp40') }};</span>
        </p>
        <p>
            <span>{{ trans('pp41') }};</span>
        </p>
        <p>
            <span>{{ trans('pp42') }};</span>
        </p>
        <p>
            <span>{{ trans('pp43') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp44') }}:</span>
        </p>
        <p>
            <span>{{ trans('pp45') }};</span>
        </p>
        <p>
            <span>{{ trans('pp46') }};</span>
        </p>
        <p>
            <span>{{ trans('pp47') }};</span>
        </p>
        <p>
            <span>{{ trans('pp48') }};</span>
        </p>
        <p>
            <span>{{ trans('pp49') }}.</span>
        </p>
        <p>
            <span>{{ trans('pp50') }}.</span>
        </p>
        <p>
            <strong><span>{{ trans('pp51') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp52') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp53') }} </span><span lang="EN-US">«</span><span>{{ trans('pp54') }}</span><span lang="EN-US">» </span><span>{{ trans('pp55') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp56') }}.</span>
        </p>

        <p>
            <strong><span>{{ trans('pp57') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp58') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp59') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp60') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp61') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp62') }} </span><span lang="EN-US">«</span><span>{{ trans('pp63') }}</span><span lang="EN-US">» </span><span>{{ trans('pp64') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp65') }}.</span>
        </p>

        <p>
            <strong><span>{{ trans('pp66') }}</span></strong>
        </p>
        <p>
            <span>{{ trans('pp67') }}<span>&nbsp; </span>{{ trans('pp68') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp69') }}.</span>
        </p>

        <p>
            <span>{{ trans('pp70') }}.</span>
        </p>

        <p>
            <strong><span>{{ trans('pp71') }}</span></strong>
        </p>
        <p>
      <span>
        {{ trans('pp72') }}
        <a href="mailto:arendaipzakharova@yandex.ru" class="article__link">arendaipzakharova@yandex.ru</a>
      </span>
        </p>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
